module.exports = {};



// WEBPACK FOOTER //
// node_modules/core-js/modules/_iterators.js